export function request(body) {
    return {
        type: 'ADD_NEW_BANNER_REQUEST',
        body
    };
}

export function error(errors) {
    return {
        type: 'ADD_NEW_BANNER_ERROR',
        errors
    };
}

export function finish(data) {
    return {
        type: 'ADD_NEW_BANNER_FINISH',
        data
    };
}
